// src/App.js
import React from 'react';
import './App.css'
import './styles/responsive.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import Services from './pages/Services';
import Difference from './pages/Difference';
import Profile from './pages/Profile';
import ContactUs from './pages/ContactUs';
import BookDemo from './pages/BookDemo';
import './App.css';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <div className="container main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/difference" element={<Difference />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/BookDemo" element={<BookDemo />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;